import React from 'react';
import { getCookie } from 'cookies-next';
import { Oewa } from '@components/atoms/Oewa/Oewa';
import { Provider } from '@components/atoms/Provider/Provider';
import { Title } from '@components/atoms/Title';
import { providers } from '@utils/providers';
import { useTagManager } from '@lib/hooks/useTagManager';

export function ProviderIndex() {
  useTagManager({
    event: 'metadata',
    loginStatus: 'nicht eingeloggt',
    seitentyp: 'Provider Übersicht',
    titel: 'Provider Übersicht',
    oewaSeitenkontingent: 'Service',
    oewaSubkontingent: 'Programmeundlokalfuehrer',
    oewaProfilingkontingent: 'TVProgramme',
    cookieAlert: getCookie('OptanonConsent'),
  });

  return (
    <div>
      <Oewa pageKey={'Service'} categoryKey={'Programmeundlokalfuehrer'} profileKey={'TVProgramme'} />
      <Title classProps={{ heading: 'text-xl lg:text-xl mb-6' }} level={1}>
        Provider
      </Title>
      <div className="grid grid-cols-fill-streaming-squares gap-4">
        {providers?.map((provider) => <Provider key={provider.id} provider={provider} style="box" />)}
      </div>
    </div>
  );
}

export async function providerIndexSsrLogic() {
  return {
    props: {
      slug: 'index',
    },
  };
}
